<template>
  <footer class="bg-gradient-to-b from-gray-900 to-gray-800 text-white pt-16 pb-8">
    <div class="container mx-auto px-4 sm:px-6 lg:px-8">
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-10 lg:gap-8">
        <!-- Company Info -->
        <div class="lg:col-span-4">
          <div class="flex items-center mb-4">
            <span class="text-2xl font-extrabold bg-gradient-to-r from-primary-400 to-primary-600 bg-clip-text text-transparent">
              维域科技
            </span>
            <span class="ml-2 text-xs font-medium text-primary-400 bg-primary-900/30 px-2 py-1 rounded-full">
              Weiyu Tech
            </span>
          </div>
          <p class="text-gray-400 text-sm leading-relaxed mb-6">
            我们专注于边缘计算与数据智能领域，致力于为客户提供高性能、低成本的边缘计算解决方案，
            推动低空经济与具身智能的创新发展。
          </p>
        </div>

        <!-- Quick Links -->
        <div class="lg:col-span-2">
          <h4 class="text-base font-semibold text-white mb-4 flex items-center">
            <span class="h-0.5 w-4 bg-primary-500 mr-2"></span>
            快速链接
          </h4>
          <ul class="space-y-3">
            <li>
              <router-link 
                to="/about" 
                class="text-sm text-gray-400 hover:text-primary-400 transition-colors duration-200 flex items-center group"
                @click="$emit('navigate')"
              >
                <span class="w-1 h-1 rounded-full bg-gray-600 mr-2 group-hover:bg-primary-400 transition-colors"></span>
                关于我们
              </router-link>
            </li>
            <li>
              <router-link 
                to="/solutions" 
                class="text-sm text-gray-400 hover:text-primary-400 transition-colors duration-200 flex items-center group"
                @click="$emit('navigate')"
              >
                <span class="w-1 h-1 rounded-full bg-gray-600 mr-2 group-hover:bg-primary-400 transition-colors"></span>
                解决方案
              </router-link>
            </li>
            <li>
              <router-link 
                to="/projects" 
                class="text-sm text-gray-400 hover:text-primary-400 transition-colors duration-200 flex items-center group"
                @click="$emit('navigate')"
              >
                <span class="w-1 h-1 rounded-full bg-gray-600 mr-2 group-hover:bg-primary-400 transition-colors"></span>
                项目案例
              </router-link>
            </li>
            <li>
              <router-link 
                to="/careers" 
                class="text-sm text-gray-400 hover:text-primary-400 transition-colors duration-200 flex items-center group"
                @click="$emit('navigate')"
              >
                <span class="w-1 h-1 rounded-full bg-gray-600 mr-2 group-hover:bg-primary-400 transition-colors"></span>
                加入我们
              </router-link>
            </li>
          </ul>
        </div>

        <!-- Contact Info -->
        <div class="lg:col-span-3">
          <h4 class="text-base font-semibold text-white mb-4 flex items-center">
            <span class="h-0.5 w-4 bg-primary-500 mr-2"></span>
            联系我们
          </h4>
          <ul class="space-y-4">
            <li class="flex items-start">
              <div class="flex-shrink-0 h-5 w-5 text-primary-500 mt-0.5">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
              </div>
              <p class="ml-3 text-sm text-gray-400">
                上海市宝山区长江南路180号长江软件园A525室
              </p>
            </li>
            <li class="flex items-center">
              <svg class="h-5 w-5 text-primary-500 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
              </svg>
              <a href="mailto:contact@weiyu-tech.com" class="ml-3 text-sm text-gray-400 hover:text-primary-400 transition-colors duration-200">
                public@weiyutek.com
              </a>
            </li>
            <li class="flex items-center">
              <svg class="h-5 w-5 text-primary-500 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
              </svg>
              <a href="tel:021-5273 0582" class="ml-3 text-sm text-gray-400 hover:text-primary-400 transition-colors duration-200">
                021-5273 0582
              </a>
            </li>
          </ul>
        </div>
      </div>

      <!-- Solutions -->
      <div class="lg:col-span-3">
        <h4 class="text-base font-semibold text-white mb-4 flex items-center">
          <span class="h-0.5 w-4 bg-primary-500 mr-2"></span>
          解决方案
        </h4>
        <div class="grid grid-cols-2 gap-4">
          <div v-for="(solution, index) in solutions" :key="index" class="mb-2">
            <router-link 
              :to="solution.href" 
              class="text-sm text-gray-400 hover:text-primary-400 transition-colors duration-200 flex items-start group"
              @click="$emit('navigate')"
            >
              <svg class="h-4 w-4 text-primary-500 mr-2 mt-0.5 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
              </svg>
              <span>{{ solution.name }}</span>
            </router-link>
          </div>
        </div>
      </div>
    </div>

    <!-- Copyright & Social -->
    <div class="border-t border-gray-800 mt-12 pt-8">
      <div class="container mx-auto px-4 sm:px-6 lg:px-8">
        <div class="flex flex-col md:flex-row justify-between items-center">
          <p class="text-sm text-gray-500 text-center md:text-left">
            <a href="https://beian.miit.gov.cn/">沪ICP备13000329号</a>
            <br></br>
            &copy; 2012-{{ new Date().getFullYear() }} 上海维域信息科技有限公司 版权所有
            
            
          </p>
          
          <div class="flex space-x-6 mt-4 md:mt-0">
            <a href="#" class="text-gray-400 hover:text-white transition-colors duration-200" aria-label="微信公众号">
              <svg class="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
                <path d="M8.84 10.45c.1-.05.52-.26 1-.25 1.5.03 2.7 1.26 2.68 2.77-.01 1.51-1.23 2.73-2.73 2.73-.5 0-.92-.18-1.02-.24-.13-.08-.27.06-.27.19v1.36c0 .17.11.25.25.25h4.5c.14 0 .25-.11.25-.25v-4.5c0-.14-.11-.25-.25-.25h-4.5c-.14 0-.25.11-.25.25v1.25c0 .13.13.27.26.19zM12 0C5.37 0 0 5.37 0 12s5.37 12 12 12 12-5.37 12-12S18.63 0 12 0zm0 22c-5.52 0-10-4.48-10-10S6.48 2 12 2s10 4.48 10 10-4.48 10-10 10z"/>
              </svg>
            </a>
            <a href="#" class="text-gray-400 hover:text-white transition-colors duration-200" aria-label="LinkedIn">
              <svg class="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
                <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
              </svg>
            </a>
            <a href="#" class="text-gray-400 hover:text-white transition-colors duration-200" aria-label="GitHub">
              <svg class="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
                <path fill-rule="evenodd" d="M12 2C6.477 2 2 6.484 2 12.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0112 6.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.202 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.943.359.309.678.919.678 1.852 0 1.336-.012 2.415-.012 2.743 0 .267.18.578.688.48A10.019 10.019 0 0022 12.017C22 6.484 17.522 2 12 2z" clip-rule="evenodd"/>
              </svg>
            </a>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup>
import { ref } from 'vue';

const solutions = ref([
  { name: '边缘计算平台', href: '/solutions/edge-computing' },
  { name: '数据智能分析', href: '/solutions/data-analytics' },
  { name: 'AI 解决方案', href: '/solutions/ai-solutions' },
  { name: '低空经济', href: '/solutions/low-altitude-economy' },
  { name: '具身智能', href: '/solutions/embodied-ai' },
  { name: '行业定制方案', href: '/solutions/custom-solutions' },
]);

const quickLinks = ref([
  { name: '关于我们', href: '/about' },
  { name: '解决方案', href: '/solutions' },
  { name: '项目案例', href: '/projects' },
  { name: '加入我们', href: '/careers' },
]);
</script>
